import {AbstractEvent} from "@/modules/base/events";

export class BeforeNotifyEvent extends AbstractEvent
{
}